<!-- Comportamiento Dolar -->
<div class="row">
    <div class="col-xl-8 col-lg-12">
        <div class="card">
            <div class="card-header pb-0">
                <h4 class="card-title">Comportamiento Dollar contra Peso Mexicano del {{fecha1}} al {{fecha2}}</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="chart-info mb-2">
                        <span class="mr-3">
                            <i class="fa fa-circle info font-small-2 mr-1"></i>
                            <span>Tipo de cambio Pesos por dólar E.U.A. (FIX)</span>
                        </span>
                    </div>
                    <div id="line-chart2" class="lineChart2 lineChart2Shadow">
                        <apx-chart #chartDollarFix [series]="chartDollarFixoptions?.series"
                            [chart]="chartDollarFixoptions?.chart" [colors]="chartDollarFixoptions?.colors"
                            [yaxis]="chartDollarFixoptions?.yaxis" [dataLabels]="commonOptions.dataLabels"
                            [markers]="commonOptions.markers" [stroke]="commonOptions.stroke"
                            [grid]="commonOptions.grid" [xaxis]="commonOptions.xaxis"
                            [tooltip]="commonOptions.tooltip"></apx-chart>

                        <div class="chart-info mb-2">
                            <span>
                                <i class="fa fa-circle success font-small-2 mr-1"></i>
                                <span>Tipo de Cambio Cierre de Jornada</span>
                            </span>
                        </div>
                        <apx-chart #chartDollarCierre [series]="chartDollarCierreoptions?.series"
                            [chart]="chartDollarCierreoptions?.chart" [colors]="chartDollarCierreoptions?.colors"
                            [yaxis]="chartDollarCierreoptions?.yaxis" [dataLabels]="commonOptions.dataLabels"
                            [markers]="commonOptions.markers" [stroke]="commonOptions.stroke"
                            [grid]="commonOptions.grid" [xaxis]="commonOptions.xaxis"
                            [tooltip]="commonOptions.tooltip"></apx-chart>

                        <!-- <x-chartist class="height-350" [data]="lineChartDollar.data" [type]="lineChartDollar.type"
              [options]="lineChartDollar.options" [responsiveOptions]="lineChartDollar.responsiveOptions"
              [events]="lineChartDollar.events">
            </x-chartist> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4 col-lg-12 col-12">
        <div class="card gradient-purple-bliss">
            <div class="card-content">
                <div class="card-body">
                    <h4 class="card-title white">Dollar Fix</h4>
                    <div class="p-2 text-center">
                        <!-- <a class="white font-medium-1">Mes</a> -->
                        <!-- <a class="btn round bg-light-info mx-3 px-3">Semanal</a> -->
                        <a class="white font-medium-1">{{fechaFix}}</a>
                    </div>
                    <div class="my-3 text-center white">
                        <div class="font-large-2 d-block mb-1">
                            <span>${{dollarDia}}</span>
                            <i class="ft-arrow-up font-large-2" *ngIf="esMayorFix"></i>
                            <i class="ft-arrow-down font-large-2" *ngIf="!esMayorFix"></i>
                        </div>
                        <!-- <span class="font-medium-1">Week2 +15.44</span> -->
                    </div>
                </div>
                <!-- <div id="lineChart" class="lineChart lineChartShadow">
            <x-chartist class="height-250" [data]="lineChart.data" [type]="lineChart.type" [options]="lineChart.options"
              [responsiveOptions]="lineChart.responsiveOptions" [events]="lineChart.events">
            </x-chartist>
        </div> -->
            </div>
        </div>
        <div class="card gradient-purple-bliss">
            <div class="card-content">
                <div class="card-body">
                    <h4 class="card-title white">Dollar Cierre de Jornada</h4>
                    <div class="p-2 text-center">
                        <!-- <a class="white font-medium-1">Mes</a> -->
                        <!-- <a class="btn round bg-light-info mx-3 px-3">Semanal</a> -->
                        <a class="white font-medium-1">{{fechaCierre}}</a>
                    </div>
                    <div class="my-3 text-center white">
                        <div class="font-large-2 d-block mb-1">
                            <span>${{dollarDiaCierre}}</span>
                            <i class="ft-arrow-up font-large-2" *ngIf="esMayorCierre"></i>
                            <i class="ft-arrow-down font-large-2" *ngIf="!esMayorCierre"></i>
                        </div>
                        <!-- <span class="font-medium-1">Week2 +15.44</span> -->
                    </div>
                </div>
                <!-- <div id="lineChart" class="lineChart lineChartShadow">
            <x-chartist class="height-250" [data]="lineChart.data" [type]="lineChart.type" [options]="lineChart.options"
              [responsiveOptions]="lineChart.responsiveOptions" [events]="lineChart.events">
            </x-chartist>
        </div> -->
            </div>
        </div>
    </div>
</div>

<!--END Comportamiento Dolar -->